/**
 * Any getters for easy access to things in store
 */
export const getters = {
  userEvents: state => state.events,
  getProps: state => state.defaultProps,
  getIcon: () => 'pulse',
};
